import { all, fork, put, select, takeLeading } from "typed-redux-saga";
import { Action, viewSettingsActions } from "./view-settings-store";
import { applicationActions } from "src/components/application-store";
import { configuratorActions } from "../../configurator-store";
import { IDENTITY_SETTINGS_KEYS } from "src/utils/types/identity-settings-types";
import { RootState } from "src/store";

// ApplicationWrapper gates all routed pages behind contactPersonDetails.loading === "has-loaded",
// and application-saga's contactPersonDetails() saga populates identitySettings BEFORE that flag
// flips — so by the time this fires on Configurator mount, the stored value is already in Redux
// with no network round trip and no race to guard against.
export function* loadPersistedViewSettings(action: ReturnType<typeof viewSettingsActions.loadPersistedRequest>) {
  const stored = yield* select((state: RootState) => state.generalReducer.applicationReducer.identitySettings[IDENTITY_SETTINGS_KEYS.CONFIGURATOR_VIEW_SETTINGS]);
  if (stored) {
    yield put(viewSettingsActions.loadPersistedSuccess(stored.selectedItemIds ?? []));
  }
  yield put(configuratorActions.getConfigurationsRequest(action.payload.projectId));
}

export function* watchLoadPersistedViewSettings() {
  yield takeLeading(Action.LoadPersistedRequest, loadPersistedViewSettings);
}

// Delegates the actual persistence to the app-wide identitySettings mechanism (application-saga's
// watchSetIdentitySettings), which already resolves identityId and handles its own error reporting.
export function* saveViewSettingsOnApply() {
  const applied = yield* select((state: RootState) => state.pageReducer.combinedConfiguratorReducer.viewSettingsReducer.applied);
  yield put(applicationActions.setIdentitySettingsRequest(IDENTITY_SETTINGS_KEYS.CONFIGURATOR_VIEW_SETTINGS, JSON.stringify(applied)));
}

export function* watchApplyDraftForPersistence() {
  yield takeLeading(Action.ApplyDraft, saveViewSettingsOnApply);
}

export function* viewSettingsSaga() {
  yield all([fork(watchLoadPersistedViewSettings), fork(watchApplyDraftForPersistence)]);
}
